import { all, fork } from "redux-saga/effects";
import { addressWatcherSaga } from "./addressSaga";
import { bannerWatcherSaga } from "./bannerSaga";
import { blogCategoryWatcherSaga } from "./blogcategorySaga";
import { blogsWatcherSaga } from "./blogsSaga";
import { categoryWatcherSaga } from "./categorySaga";
import { customerWatcherSaga } from "./customerSaga";
import { offerWatcherSaga } from "./offerSaga";
import { ordersWatcherSaga } from "./ordersSaga";
import { productWatcherSaga } from "./productSaga";
import { reviewWatcherSaga } from "./reviewSaga";
import { userWatcherSaga } from "./userSaga";
import { calculationWatcherSaga } from "./calculationSaga";
import { otpWatcherSaga } from "./otpSaga";
import { razorPayWatcherSaga } from "./razorpaySaga";
import { contactAsWatcherSaga } from "./contactAsSaga";
import { stateWatcherSaga } from "./stateSaga";
import { delhiveryWatcherSaga } from "./delhivery";
import { supportTicketsWatcherSaga } from "./supportticketsSaga";

export default function* rootSaga() {
  yield all([
    fork(addressWatcherSaga),
    fork(bannerWatcherSaga),
    fork(blogCategoryWatcherSaga),
    fork(blogsWatcherSaga),
    fork(categoryWatcherSaga),
    fork(customerWatcherSaga),
    fork(offerWatcherSaga),
    fork(ordersWatcherSaga),
    fork(productWatcherSaga),
    fork(reviewWatcherSaga),
    fork(userWatcherSaga),
    fork(calculationWatcherSaga),
    fork(otpWatcherSaga),
    fork(razorPayWatcherSaga),
    fork(contactAsWatcherSaga),
    fork(stateWatcherSaga),
    fork(delhiveryWatcherSaga),
    fork(supportTicketsWatcherSaga),
  ]);
}
